// APIs, Data, Constants, CSS Imports Here...
import metaConfig from '../../assets/services/metaConfig'
import './WebsiteComp.css'
import '../../../node_modules/bootstrap/dist/css/bootstrap.css'

// React Hook Imports Here...
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'


export const WebsiteComp = ({webComp}) => {

  const routePath = useLocation();
  const metaData = metaConfig?.[routePath.pathname] !== undefined  && metaConfig?.[routePath.pathname] !== null ? metaConfig?.[routePath.pathname] : "";


  useEffect(() => {
        if(metaData !== ""){
            document.title = metaData.title;
            const setOrCreateMeta = (name, content) => {
                let metaElement = document.querySelector(`meta[name="${name}"]`);
                if (metaElement) {
                    metaElement.setAttribute('content', content);
                } else {
                    metaElement = document.createElement('meta');
                    metaElement.name = name;
                    metaElement.content = content;
                    document.head.appendChild(metaElement);
                }
            };
            ['title', 'keywords', 'description', 'structuredData'].forEach((key) => {
                setOrCreateMeta(key, metaData[key]);
            });
        }
    }, [metaData]);

  return (
    <>
      {webComp}
    </>
  )
}
